import { useEffect, useState, SubmitEvent, SubmitEventHandler } from 'react'
import Link from 'next/link'
import billingCycles from '@/data/billingcycles'
import Label from '@/components/common/Label'
import { className } from '@/components/common/styles'
import { isIterableArray } from '@/lib/helpers'
import Panel from '@/components/common/Panel'

const BillingCycle = () => {
  const selected = billingCycles.findIndex(
    (billingCycle) => billingCycle.selected,
  )
  const [billingCycle, setBillingCycle] = useState(
    billingCycles[selected].label,
  )
  useEffect(() => setBillingCycle(billingCycles[selected].label), [selected])

  const handleBillingCycleSettings: SubmitEventHandler = (
    e: SubmitEvent<HTMLInputElement>,
  ) => {
    e.preventDefault()
    console.log({
      billingCycle,
    })
  }

  return (
    <div className="p-4">
      <Panel title="Billing cycle">
        <form onSubmit={handleBillingCycleSettings}>
          <div className="grid grid-cols-2 gap-x-8">
            <div className="col-span-2">
              <Label
                id="billingCycle"
                label="Billing cycle"
                tooltip="Annual billing saves 20% in costs compared to monthly billing."
                icon="info-circle"
                ttid="tt-billing-cycle-id"
                value={billingCycle}
                type="select"
                populate={
                  isIterableArray(billingCycles) &&
                  billingCycles.map((item) => (
                    <option
                      value={item.label}
                      disabled={item.disabled ?? false}
                      key={item.label}
                    >
                      {item.label}
                    </option>
                  ))
                }
                onChange={() => console.log('change')}
              />
              {/*
                      ({ target }) =>
                      setPlan((target as HTMLInputElement).value)
                    */}
            </div>
            <div className="col-span-2 text-sm text-theme-gray-500 dark:text-theme-gray-400 pb-2">
              You are billed USD$ 576.00 annually.
              <br />
              Annual saving is USD$ 144.00 (USD$ 12.00 per month).
            </div>
            <div className="col-span-2 pb-4">
              <Link href="#!">
                <div className="text-theme-blue-600 dark:text-theme-blue-400 hover:underline decoration-2">
                  Read more about switching your billing cycle
                </div>
              </Link>
            </div>
            <div className="col-span-2 pb-6">
              <button
                className={`${className} float-end`}
                type="submit"
                onClick={() => console.log('click button')}
              >
                {/* {handleBillingCycleSettings} */}
                Switch billing
              </button>
            </div>
          </div>
        </form>
      </Panel>
    </div>
  )
}

export default BillingCycle
